import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/bod-item", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/bod-item/csv", params);
};

const upsert = data => {
  return restApi.post("/api/bod-item/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/bod-item/${ids}`);
};

const bodItemService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default bodItemService;